module.exports = __webpack_public_path__ + "static/media/opengraphcover.877d270b.png";